import { render, staticRenderFns } from "./importerAddressAdd.vue?vue&type=template&id=07b3f1d8&scoped=true"
import script from "./importerAddressAdd.vue?vue&type=script&lang=js"
export * from "./importerAddressAdd.vue?vue&type=script&lang=js"
import style0 from "./importerAddressAdd.vue?vue&type=style&index=0&id=07b3f1d8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b3f1d8",
  null
  
)

export default component.exports